import { TGetEmployeeItem } from "../../../../../api/employee/employee.types";

export type TOnCandidateChangeFn = (
  op: string,
  candidate: Partial<TGetEmployeeItem>
) => void;

export type TOnCandidateSelectFn = (
  candidate: Partial<TGetEmployeeItem>
) => void;

export type TOnCandidateMultiSelectFn = (
  candidate: Partial<TGetEmployeeItem>
) => void;

export enum ECandidateProfileTab {
  PROFILE = "profile",
  VIDEO_INTERVIEW = "videoInterview",
  PUBLIC_PROFILE = "publicProfile",
  APPLIED_OFFERS = "appliedOffers",
  CONTRACTS = "contracts",
  VALUATIONS = "valuations",
  INTERVIEWS = "interviews",
  MESSAGES = "messages",
  DOCUMENTS = "documents",
}
